<template>
  <div class="details-card-wrapper">
    <b-card header="true" header-tag="header">
      <div
        slot="header"
        class="d-flex justify-content-between align-items-center"
      >
        <p class="mb-0 d-inline-block align-middle">
          <b>Informazioni</b>
        </p>
      </div>
      <div class="details-card custom-grid-wrapper">
        <template v-for="(field, index) in fields">
          <div :class="{
              even: index % 2 === 0,
              odd: index % 2 !== 0,
              'grid-item-label': true,
            }"
               :key="`if_1_${index}`">
            <strong>{{ field.label.toUpperCase() }}</strong>
          </div>
          <div
            :class="{
              even: index % 2 === 0,
              odd: index % 2 !== 0,
              'grid-item-value': true,
            }"
            :key="`else_1_${index}`">
            {{ renderDbRowData(field, dbRowData) }}
          </div>
        </template>
      </div>
    </b-card>
  </div>
</template>

<script>
import FormMixin from "@/mixins/FormMixin";
import {renderDbRowData} from "@/utils/payments";

export default {
  mixins: [FormMixin],
  name: "General",
  props: {
    resourceId: Number,
    dbRowData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      details: null,
      repository: "insurance_payment",
      allRepositories: [],
      isLoading: true,
      defaultLabels: {
        insurance_payment: {},
      },
      fields: [
        {
          label: this.getDictionary("insurer"),
          value: "compagnia",
        },
        {
          label: this.getDictionary("insurance_policy"),
          value: "number",
        },
        {
          label: this.getDictionary("expired_at"),
          value: "expired_at",
        },
        {
          label: this.getDictionary("contractor"),
          value: "contraente",
        },
        {
          label: this.getDictionary("status_payment", "insurance_payment"),
          option: "status_payment",
          value: "status_payment.text",
        },
        {
          label: this.getDictionary("payment_type", "insurance_payment"),
          option: "payment_type",
          value: "payment_type.text",
        },
        {
          label: this.getDictionary("gross", "insurance_payment"),
          value: "gross",
        },
        {
          label: this.getDictionary("comment", "insurance_payment"),
          value: "comment",
        },
      ],
    };
  },
  methods: {
    renderDbRowData,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.col-md-4.border-bottom {
  color: rgb(63, 60, 60);
  font-weight: bold;
}
</style>
